import styled from 'styled-components';

export const Frame = styled.iframe`
	width: 100%;
	height: 100%;
	border: 0;
	display: block;
`;
